import React,{useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopEveluationReport from './_PopEvaluationReport';
function AttendanceSchool() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"당일 출석부", cnt:"435", value:0},
    {title:"출석 미체크", cnt:"5", value:1},
    {title:"결석", cnt:"5", value:2},
  ];
  const [modalEveluationReport, setModalEveluationReport] = useState(false);
  return (
    <main className="com_container com_attendance">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu12_2'>수시 출석부</h2>
          <button onClick={() => setModalEveluationReport(true)} className="com_btn orange s btn_plus">수시 보고서 작성</button>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className='com_board_list__top'>
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <span className="com_check_box">
                <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                <label htmlFor="chk010">지난 수업</label>
              </span>
              <section className='com_board_search end'>
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <span className="bar" />
                <article className='search'>
                  <input type="search" placeholder='검색할 내용을 입력해 주세요.' className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            
            <table className='com_board_list'>
              <colgroup>
                <col width="5%"/><col width="8%"/>
                <col width="8%"/><col width="8%"/>
                <col width="8%"/><col width="8%"/>
                <col width="8%"/><col width="8%"/>
                <col width="8%"/><col width="15%"/>
                <col width="8%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>최근 수업일</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>수업상세</th>
                  <th>교사명</th>
                  <th>담임명</th>
                  <th>회차 / T</th>
                  <th>진행 회차</th>
                  <th>출석 현황</th>
                  <th>최근 출석</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td className='td_date'>2022.08.25 12:30</td>
                  <td><button className="name btn_link">김길동111</button></td>
                  <td>수학</td>
                  <td>수학영역</td>
                  <td><button className="name btn_link">김교사103</button></td>
                  <td><button className="name btn_link">김담임103</button></td>
                  <td>16 / 2T</td>
                  <td className='td_point'>첫수업</td>
                  <td>출석5 | 결석2조퇴5 | 연기 5</td>
                  <td className='td_red'>미체크</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className='td_date'>2022.08.25 12:30</td>
                      <td><button className="name btn_link">김길동111</button></td>
                      <td>수학</td>
                      <td>수학영역</td>
                      <td><button className="name btn_link">김교사103</button></td>
                      <td><button className="name btn_link">김담임103</button></td>
                      <td>16 / 2T</td>
                      <td>10</td>
                      <td>출석5 | 결석2조퇴5 | 연기 5</td>
                      <td className='td_point'>결석</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <Paging />
          </section>
        </section>
        <PopEveluationReport open={modalEveluationReport} close={() => setModalEveluationReport(false)} />
      </div>
    </main>
  );
}

export default AttendanceSchool;
